const USER_DATA = {
  email: '',
};

export function storeUserEmail(email) {
  USER_DATA.email = email;
}

export function getUserEmail() {
  return USER_DATA.email;
}
